import {
    WithStyles,
    withStyles,
    Button,
    Grid,
    Card,
    CardHeader,
    IconButton,
    Typography,
    Collapse,
    CardContent,
    FormControlLabel,
    Checkbox,
    TextField,
    MenuItem,
  } from "@material-ui/core";
  // import MyPATDropDown from '../../common/MyPATDropDown';
  import PerfectScrollbar from 'react-perfect-scrollbar';
  import cx from 'classnames';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../../content-request/styles";
  import { MyPATDropdown } from "../../common";
  import { bindActionCreators } from 'redux';
  import 'react-date-range/dist/styles.css';
  import 'react-date-range/dist/theme/default.css';
  import { DateRange} from 'react-date-range';
import Placeholder from "react-select/src/components/Placeholder";
 import {format} from "date-fns";

  interface DateRangePickerProps extends WithStyles<typeof userStyles> {
    dateFilter: any,
    setDateFilter: Function,
    activeTab: string,
    dropDownObject:any,
    labelKey:string,
    valueKey:string,
    selectedDateType:any,
    placeholder:string,
    onChangeDropDown:Function,
    startDate:any,
    endDate:any,
    onChangeDateFilter:Function
  }
  
  interface DateRangePickerState {
    expandedFilter: boolean;
    startDate: null,
    endDate: null,
    type: string,
    label: string,
    showDateRange: boolean,
    dateFilterState: any,
}

  class DateRangePicker extends Component<DateRangePickerProps, DateRangePickerState> {
    constructor(props:DateRangePickerProps){
		super(props);
		this.state = {
            expandedFilter: true,
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            type: 'Select Date Type',
            label:'Select Date Type',
            showDateRange: false,
            dateFilterState: [
                {
                  startDate:this.props.startDate|| new Date(),
                  endDate:this.props.endDate|| null,
                  key: 'selection'
                }
              ]
        };
    }  

    filterExpandClick = (value: any) => {
		this.setState({
			expandedFilter: !this.state.expandedFilter
		})
    }

    setDateFilter = (item: any) => {
      this.setState({
        dateFilterState: [item.selection]
      })
      let startDate=format(item.selection.startDate,"yyyy-MM-dd");
      startDate=startDate+'T00:00:00.000Z';
      let endDate=format(item.selection.endDate,"yyyy-MM-dd");
      endDate=endDate+'T23:59:59.000Z';
      this.props.setDateFilter(startDate,endDate);
    }

    selectType = (selected: any) => {
      this.setState({
        type: selected.value,
        label: selected.label
      })
    }
    
    handleDateRangeBox = () => {
      this.setState({showDateRange: !this.state.showDateRange});
    }

    // handleDateFilterChange = (type: string) => {
    //   // this.selectType(DateTypeMap[type]
    //   console.log(type);
    //   const value = DateFilterTypes.forEach((dateType:any) => {
    //     if(dateType.label === type){
    //       console.log(dateType.value)
    //       this.selectType(dateType);
    //     }
    //   })
    //   // return DateFilterTypes.find(({ value }) => value === type)
    // }
    
    render() {
      const {classes,onChangeDropDown,placeholder,dropDownObject,selectedDateType,labelKey,valueKey} = this.props;
      const {expandedFilter, showDateRange} = this.state;
      return (
        <Card classes={{root: classes.customCard}} elevation={0}>
          <CardHeader
            action={
              <>
                <div className={classes.marginTop12}>
                  <IconButton
                    className={cx(classes.expand, {
                      [classes.expandOpen]: !expandedFilter
                    })}
                    onClick={(e) => this.filterExpandClick(e.target)}
                    aria-expanded={true}
					aria-label="show more"
                  >
                    <ExpandMoreIcon fontSize="small" height="1.5em" />
                  </IconButton>
                </div>
              </>
            }
            title={
              <Typography component="h6" variant="body1">
                Date
              </Typography>
            }
            className={classes.cardHeader}
          />
          <Collapse in={expandedFilter} classes={{container: classes.epansionPanelBody}} timeout="auto" unmountOnExit>
            {/* <CardContent className={cx(classes.scrollBarX, classes.collapsibleContainer, 'crDateCollapse')}> */}
                  <Grid container>
                      <Grid item xs={12} className="dropdownPosition">
                          <MyPATDropdown 
                          placeholder={placeholder}
                          dropdownItems={dropDownObject}
                          selectedItem = {selectedDateType}
                          onChange={onChangeDropDown}
                          labelKey={labelKey}
                          valueKey={valueKey}
                          />
                        </Grid>
                   </Grid>
                      <Grid className={classes.dateRangeCollapse}
                      onClick={this.handleDateRangeBox}>
                        <Grid container justify="space-between">
                            <Grid item>
                              <Grid className={[classes.paddingLeftSM, "dateLabelPanel"].join(' ')}>
                              <Typography className={classes.dateLabel} align="left">From Date</Typography>
                              <Typography align="left" className={[classes.dateLabel, classes.fontSize16, classes.textCapitalize, classes.blackColor].join(' ')}>Select Start Date</Typography>
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Grid className={[classes.paddingRightSM, "dateLabelPanel"].join(' ')}>
                              <Typography className={classes.dateLabel} align="right">To Date</Typography>
                              <Typography align="right" className={[classes.dateLabel, classes.fontSize16, classes.textCapitalize, classes.blackColor].join(' ')}>Select End Date</Typography>
                              </Grid>
                            </Grid>
                        </Grid>
                      </Grid>
                       {showDateRange && 
                      <Grid item xs={12} className={classes.dateRangePicker}> 
                      <Grid container></Grid>                       
                        <Grid>                
                          <DateRange
                            editableDateInputs={true}
                            onChange={item => this.setDateFilter(item)}
                            moveRangeOnFirstSelection={false}
                            ranges={this.state.dateFilterState}
                            // initialFocusedRange={startDate: new Date(), endDate: new Date()}
                          />
                        </Grid>
                      </Grid>
                      }
          </Collapse>
        </Card>
      );
    }
  }

  const mapStateToProps = (state: any) => ({
  });

  const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
    },
    dispatch
  );
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(userStyles)(DateRangePicker));
  